import { render } from "./payments-transactions-popup.vue?vue&type=template&id=54396261&scoped=true&ts=true"
import script from "./payments-transactions-popup.vue?vue&type=script&lang=ts"
export * from "./payments-transactions-popup.vue?vue&type=script&lang=ts"

import "./payments-transactions-popup.vue?vue&type=style&index=0&id=54396261&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54396261"]])

export default __exports__